import ChartController from "./chart_controller";

export default class extends ChartController {
  connect() {
    super.connect();
    this.renderChart();
  }

  renderChart() {
    new App.$chartjs(this.canvasTarget, {
      type: "horizontalBar",
      data: {
        labels: this.labels,
        datasets: [
          {
            label: "Alarms",
            data: this.counts,
            backgroundColor: App.arrayOfRGBColors(this.labels.length, 0.75),
            borderColor: App.arrayOfRGBColors(this.labels.length),
            borderWidth: 1,
          },
        ],
      },
      options: {
        legend: {
          display: false,
        },
        scales: {
          xAxes: [{
            ticks: {
              min: 0,
              fontColor: "#2d333e"
            }
          }],
          yAxes: [{
            ticks: {
              fontColor: "#2d333e"
            }
          }]
        }
      },
    });
  }
}